
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from "framer-motion"
import { useNavigate } from 'react-router'
import { ArrowDown, ArrowRight, NewTabSVG } from "../kit/icons"
import { fetchMenu } from '../../sanity';

import Hamburger from 'hamburger-react'


const Menu = ({ hoveredMenu, setHoveredMenu, mobileOpenMenu, setMobileOpenMenu, hamburgerOpen, setHamburgerOpen, settings }) => {
    const { mainColor } = settings;
    const [menu, setMenu] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const router = useNavigate();



    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            try {
                const data = await fetchMenu();
                setMenu(data);
            } catch (error) {
                console.error('Error fetching settings:', error);
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, []);


    const openLink = (item) => {
        switch (item.linkType) {

            case "page":
                setHamburgerOpen(false)
                setMobileOpenMenu("")
                router("/" + item.page.slug.current)
                break;
            case "external":
                window.open(item.externalUrl, '_blank');
                setHamburgerOpen(false)
                setMobileOpenMenu("")
                break;
            default:
                break;
        }

    }


    const MainMenuItem = ({ item }) => {
        return (
            <motion.div
                className='h-20 pl-3 pr-3 content-center font-semibold'
                whileHover={{ background: mainColor, color: "#FFFFFF" }}
                animate={{
                    background: hoveredMenu === item.title ? mainColor : "",
                    color: hoveredMenu === item.title ? "#FFF" : "",
                    cursor: "pointer"
                }}
                onClick={() => openLink(item)}
            >
                <div className='flex'>
                    {false && item.linkType === "external" && NewTabSVG()}
                    {item.title}
                </div>
            </motion.div>
        );
    };


    const SubMenuItem = ({ item }) => {
        return (
            <div>
                <motion.div
                    className='font-semibold  inline-flex'
                    style={{ borderLeft: "#FFF 3px solid" }}
                    whileHover={{ color: mainColor, paddingLeft: "0.4rem", borderLeft: mainColor + " 3px solid" }}
                    animate={{
                        background: hoveredMenu === item.title ? mainColor : "",
                        color: hoveredMenu === item.title ? "#FFF" : "",
                        cursor: "pointer"
                    }}
                    onClick={() => openLink(item)}
                >
                    {item.linkType === "external" && NewTabSVG()}
                    {item.title}
                </motion.div>
            </div>
        );
    };

    const MobileMenuItem = ({ item }) => {
        return (<>
            <motion.div
                className='h-12 pl-4 content-center font-semibold bg-white'
                style={{ width: "calc(100% - 1rem)" }}
                whileHover={{ background: "#e5e5e5" }}
            >
                <div className='flex justify-between pointer'>
                    <motion.div className='h-12 p-1 pointer flex align-center justify-left items-center w-full'
                        whileHover={{ background: "#e5e5e5" }}
                        onClick={() => openLink(item)}

                    >
                        {item.title}
                    </motion.div>

                    <motion.div className='h-12 w-12 p-1 pointer flex align-center justify-center items-center '
                        whileHover={{ background: "#e5e5e5" }}
                        onClick={() => mobileOpenMenu === item.title ? setMobileOpenMenu("") : setMobileOpenMenu(item.title)}
                    >
                        {mobileOpenMenu === item.title ? <ArrowDown /> : <ArrowRight />}
                    </motion.div>
                </div>
            </motion.div>
            {menu?.filter((m) => m.type === "product" && m.category.title === item.title && item.title === mobileOpenMenu).map((sitem) => {
                return <motion.div
                    key={sitem.title + "submenum"}
                    className='h-12 pl-8 pr-0 content-center font-semibold bg-white'
                    style={{ width: "calc(100% - 1rem)" }}
                    animate={{
                        cursor: "pointer"
                    }}
                    onClick={() => openLink(sitem)}
                >
                    <div className='flex justify-between'>
                        {sitem.title}

                    </div>
                </motion.div>
            }
            )

            }
        </>
        );
    };

    const SubMenuItem2 = ({ item, i }) => {
        return (
            <motion.div className='absolute'
                style={{
                    fontSize: "14px",
                    display: "block",
                    position: 'absolute',
                    marginTop: 36 * i + "px",
                    background: "#FFFFFF",
                    width: "220px",
                    height: "36px",
                    lineHeight: "36px",
            }}>
                <motion.div
                  
                    style={{
                        display: "block",
                        background: "#FFFFFF",
                        width: "220px",
                        paddingLeft: "8px",
                        height: "36px",
                        lineHeight: "36px",

                    }}
                    onClick={() => openLink(item)}

                    whileHover={{ background: mainColor, color: "#FFFFFF" }}
                >
                    {item.linkType === "external" && NewTabSVG()}
                    {item.title}
                </motion.div>
            </motion.div>

        );
    };

    return (
        <>
            <div className='block lg:hidden'>
                <Hamburger color={mainColor} toggled={hamburgerOpen} toggle={setHamburgerOpen} />
                {hamburgerOpen && <div className='absolute w-screen left-0'>
                    {menu?.filter((m) => m.type === "main").sort((a, b) => (a.order > b.order ? 1 : -1)).map((item) => (
                        <div className="w-full" key={"menu" + item.title}>
                            <MobileMenuItem key={"main" + item.title} item={item} />
                        </div>
                    ))}
                    <div onMouseEnter={() => setHoveredMenu("general")} className="pointer w-full">
                        <MobileMenuItem item={{ title: "Ostatní" }} />
                    </div>
                </div>}
            </div>
            <div className="hidden lg:block">
                <AnimatePresence>
                    <div className='flex'>
                        {menu?.filter((m) => m.type === "main").sort((a, b) => (a.order > b.order ? 1 : -1)).map((item) => (
                            <div onMouseEnter={() => setHoveredMenu(item.title)} style={{ cursor: "pointer" }} key={"menu" + item.title}>
                                <MainMenuItem key={"main" + item.title} item={item} />
                                <>

                                    {
                                        item.title === hoveredMenu && menu?.filter((m) => m.type === "product" && m.category?.title === hoveredMenu).map((item2, i) => {
                                            return <SubMenuItem2 item={item2} i={i} key={item.title + i}/>

                                        })
                                    }
                                </>

                            </div>
                        ))}
                    </div>
                </AnimatePresence>




                {false && menu?.filter((m) => m.category?.title === hoveredMenu).length > 0 &&
                    <AnimatePresence>
                        <motion.div
                            className='fixed w-screen left-0 bg-white pb-6 pt-6 '
                            animate={{
                                height: hoveredMenu !== "" ? 'auto' : 0,
                                opacity: hoveredMenu !== "" ? 1 : 0,
                            }}
                            initial={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.4, ease: 'easeInOut' }}
                            style={{ overflow: 'hidden', zIndex: 99999, position: "absolute" }}
                        >
                            <div className='flex justify-center'>
                                <div className='container grid'>
                                    <div className="grid gap-1 grid-rows-[auto_auto]">
                                        <h3 className="row-span-1 text-left text-2xl font-bold pb-1">{hoveredMenu}</h3>
                                        <div className="grid grid-cols-3 gap-8 row-span-1">
                                            <div className="">
                                                {menu?.filter((m) => m.category?.title === hoveredMenu && m.type === "product").map((item) => (
                                                    <div className="mb-3" key={"products" + item.category}>
                                                        <SubMenuItem item={item} />
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mb-3">    {menu?.filter((m) => m.category?.title === hoveredMenu && m.type === "popis").map((item) => (
                                                <div className="mb-3" key={item.category + "popis"}>
                                                    <SubMenuItem item={item} />

                                                </div>
                                            ))}</div>
                                            <div className="mb-3">
                                                {menu?.filter((m) => m.type === "general").map((item) => (
                                                    <div className="mb-3" key={item.category + "general"}>
                                                        <SubMenuItem item={item} />
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                }
            </div >

        </>
    );
}

export default Menu
